// extracted by mini-css-extract-plugin
module.exports =  {"columns":"lLvAlJJ","columns-title":"Ky7AdKM","columnsTitle":"Ky7AdKM","columns-body":"Bw4yGG2","columnsBody":"Bw4yGG2"};